package pl.decks.personal.pages.ievp.sections.lastyears

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.vh
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout

object LastYearsSectionStylesheet {
    object Vars {
        val segmentHeight by StyleVariable(50.vh)
        val paragraphMaxHeight by StyleVariable(10.cssRem)
    }

    object Paragraph {
        val Container = CssStyle.base {
            Modifier
                .fillMaxWidth()
                .height(Vars.paragraphMaxHeight.value())
                .flexShrink(0)
        }
        val Current = CssStyle.base {
            Modifier
                .color(colorMode.toSitePalette().accents.secondary)
                .fontWeight(FontTypography.Weight.Medium)
        }
        val Text = FontTypography.sansSerif
        val SWIntro = FontTypography.mono
        val Emphasis = CssStyle.base {
            Modifier
                .fontWeight(FontTypography.Weight.Bold)
                .color(colorMode.toSitePalette().accents.primary)
        }
    }

    val Section = CssStyle {
        base {
            Modifier
                .fillMaxWidth()
                .setVariable(Vars.segmentHeight, 50.vh)
                .setVariable(Vars.paragraphMaxHeight, 18.5.cssRem)
        }
        Breakpoint.MD {
            Modifier
                .setVariable(Vars.segmentHeight, 25.vh)
                .setVariable(Vars.paragraphMaxHeight, 9.5.cssRem)
        }
    }
    val StickyProgress = CssStyle.base {
        Modifier
            .position(Position.Sticky)
            .fillMaxWidth()
            .height(100.vh)
            .top(SiteLayout.Offset.none)
            .overflow(Overflow.Clip)
    }
    val RollingStory = CssStyle.base {
        Modifier.fillMaxWidth()
            .translateY(Vars.paragraphMaxHeight.value())
    }
}
